import { render, staticRenderFns } from "./address-add.vue?vue&type=template&id=2196072e&scoped=true"
import script from "./address-add.vue?vue&type=script&lang=js"
export * from "./address-add.vue?vue&type=script&lang=js"
import style0 from "./address-add.vue?vue&type=style&index=0&id=2196072e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2196072e",
  null
  
)

export default component.exports